import Accordion from "@/components/common/Accordion";
import BaseCard from "@/components/common/BaseCard";
import { pxChangeVw } from "@/utils";
import { appThemeStyle } from "@/constants/theme.config";
import { Skeleton } from "antd-mobile";
import { useHourlyAdCpt as useAdCpt } from "@/hooks/adCpt/pageAds";
import { is_tr_link } from "@/i18n/lang";
import classNames from "classnames";
import { RainProbSvg } from "@/components/common/SvgIcon";
import { calcByUiRatio } from "@/constants/runtime.config";
import { hourlyListAtom } from "@/atoms/hourly";
import { homeAtom } from "@/atoms/home";
import TestTips1 from "@/components/TestTips1";

const HourlyDefault: React.FC = () => {
  const homeData = useAtomValue(homeAtom);
  const [hourList, setHourList] = useAtom(hourlyListAtom);
  const locInfo = LocalStorage.getItem("INFO");
  const { state } = useLocation();
  const expandIndex = useMemo(() => {
    if (!state?.time || !hourList.length) return 0;
    const index = hourList.findIndex((item: any) => item.Hour === state.time);
    return index >= 0 ? index : 0;
  }, [state?.time, hourList]);

  const weatherStatus = homeData?.data?.info?.weatherStatus || locInfo?.weatherStatus;
  const tipsStyle = appThemeStyle?.[weatherStatus]?.tipsStyle ?? {};
  const { pathname } = useLocation();
  const fetchHourlyData = useSetAtom(homeAtom);
  const position11Ad = useAdCpt("position-11");
  const position20Ad = useAdCpt("position-20");
  useEffect(() => {
    fetchHourlyData(pathname);
  }, []);
  const renderTitle = useCallback(({ item, index, handleClick }: any) => {
    const HourlyItemHeader = () => {
      let columnFlexRatios = [1.5, 1, 4, 2, 1.5];
      const byRatio = calcByUiRatio();
      return (
        <div
          className={classNames(["flex justify-between items-center text-12"])}
          onClick={() => handleClick(item, index)}
        >
          {/* 第1列 */}
          <div style={{ flex: columnFlexRatios[0] }}>{item.Hour}</div>
          {/* 第2列 */}
          <div style={{ flex: columnFlexRatios[1] }} className={classNames(["text-16"])}>
            {item?.Temperature?.Value + item?.Temperature?.Unit}
          </div>
          {/* 第3列 */}
          <div style={{ flex: columnFlexRatios[2] }} className={classNames(["flex items-center gap-x-5"])}>
            <WeatherImage className={classNames(["w-20"])} src={item?.WeatherIconImg} />
            <div>{item.WeatherText}</div>
          </div>
          {/* 第4列 */}
          <div style={{ flex: columnFlexRatios[3] }} className={classNames(["flex items-center gap-x-5"])}>
            <RainProbSvg width={12 * byRatio} />
            <div>{is_tr_link() ? "%" + item?.PrecipitationProbability : item?.PrecipitationProbability + "%"}</div>
          </div>
          {/* 第5列 */}
          <div style={{ flex: columnFlexRatios[4] }} className={classNames(["flex items-center justify-center"])}>
            <SvgIcon size={20 * byRatio} name={item?.isExpand ? "svg05" : "svg01"} />
          </div>
        </div>
      );
    };

    return <HourlyItemHeader />;
  }, []);
  const WarningList = ({ item }: any) => {
    return item?.warnings?.map((warningItem: any, warningIndex: number) => {
      const warning = appThemeStyle?.[weatherStatus]?.warning?.[warningItem?.Color?.Name?.toLocaleLowerCase()] ?? {};
      return (
        <EarlyWarningView
          key={warningIndex}
          title={warningItem.Description?.Localized}
          content={warningItem?.detail?.start + "-" + warningItem?.detail?.end}
          color={warning?.fontColor}
          bgColor={tipsStyle?.backgroundColor}
          fillColor={warning?.fillColor}
          AlertID={warningItem?.AlertID}
        />
      );
    });
  };

  const renderContent = useCallback(
    ({ item }: any) => {
      if (!item?.Items?.length) {
        return null;
      }

      return (
        <div className="flex flex-col gap-y-8">
          <WarningList item={item} />
          <BaseCard itemList={item.Items} useTransparentStyle={true} />
        </div>
      );
    },
    [weatherStatus, tipsStyle],
  );

  if (isEmptyType(hourList)) {
    return (
      <div
        className={classNames(["flex flex-col justify-start gap-y-10 box-border p-[0_16px]"])}
      >
        <Skeleton
          animated
          style={{
            "--width": "100%",
            "--height": pxChangeVw(390),
            "--border-radius": "10px",
          }}
        />
        {Array(23)
          .fill(undefined)
          .map((_, index) => (
            <Skeleton
              key={index}
              animated
              style={{
                "--width": "100%",
                "--height": pxChangeVw("52px"),
                "--border-radius": "10px",
              }}
            />
          ))}
      </div>
    );
  }

  return (
    <div
      className={classNames(["flex flex-col justify-start gap-y-10 box-border p-[0_16px]"])}
    >
      <TestTips1 />
      <div data-position="position-20">{position20Ad}</div>
      <div data-position="position-11">{position11Ad}</div>
      <Accordion
        accordionList={hourList}
        setLocalList={setHourList}
        renderTitle={renderTitle}
        renderContent={renderContent}
        expandIndex={expandIndex}
        isEnableScroll={state?.time}
      />
    </div>
  );
};
export default HourlyDefault;
